/* exported Pagination */
import React from "react";
import PaginationLink from "./PaginationLink";

class Pagination extends React.Component {
  constructor(props) {
    super(props);
    this.pages = [];
  }

  // TODO: rewrite paginination with state/hooks
  // because createLink() could create multiple pages
  // with same key with componentDidUpdate()
  UNSAFE_componentWillReceiveProps() {
    this.pages = [];
  }

  createLink(key, text, page) {
    const link = (
      <PaginationLink
        key={key}
        text={text}
        page={page}
        changeUrl={this.props.changeUrl}
        {...this.props}
      />
    );

    this.pages.push(link);
  }

  render() {
    const { pagination } = this.props;

    if (pagination.first_page !== 1) {
      this.createLink(1, String.fromCharCode(171), 1);
    }

    for (let p = pagination.first_page; p <= pagination.last_page; p += 1) {
      this.createLink(p, p, p);
    }

    if (pagination.count_pages !== pagination.last_page) {
      this.createLink(
        pagination.count_pages,
        String.fromCharCode(187),
        pagination.count_pages
      );
    }

    return (
      <section className="pagination clearfix">
        <h2 className="h5">Aller à la page :</h2> <ul>{this.pages}</ul>
      </section>
    );
  }
}
export default Pagination;
